module.exports = __webpack_public_path__ + "fepro/img/nft_list_bg_b.165b2fd2.png";